"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionalRiskResultSchema = void 0;
var transactional_risk_scorecard_schema_1 = require("./transactional-risk-scorecard-schema");
exports.transactionalRiskResultSchema = {
    type: 'object',
    required: [
        'transactionalRiskResultID',
        'cmhcAccountNumber',
        'accountStatusTypeCode',
        'annualHeatingCostUsedAmount',
        'applicationIDTimestamp',
        'appraisalModelPoints',
        'appraisalModelRatingTypeCode',
        'appraisalStandardAdjustmentFactor',
        'averagePropertyTaxAmountSourceTypeCode',
        'averageSellingPriceAmount',
        'benchmarkPropertySizeAmount',
        'benchmarkSellingPriceAmount',
        'canadianIncomePredictorScoreAmount',
        'cmhcFeeDiscountAmount',
        'cmhcFeesDueAmount',
        'cmhcOfficeID',
        'feeDueOverrideCode',
        'femsiAmortizationPoints',
        'femsiBorrowerCreditInconsistencyScorePoints',
        'femsiBorrowerGenericCreditScorePoints',
        'femsiBorrowerIdentityRiskPoints',
        'femsiClosingPeriodLagScorePoints',
        'femsiCoBorrowerGenericCreditScorePoints',
        'femsiCoBorrowerIdentityRiskPoints',
        'femsiLoanToValueRatioScorePoints',
        'femsiOverValuedPropertyScorePoints',
        'femsiRestrictedAccountabilityScorePoints',
        'femsiScoreCardUsedTypeCode',
        'femsiStableBorrowerPoints',
        'femsiTotalDebtServiceRatioScorePoints',
        'finalPriceEstimateAmount',
        'financialInstitutionCivicMunicipalityNameKey',
        'geocodingResultTypeCode',
        'guaranteedValuationServiceEligibleIndicator',
        'guaranteedValuationServiceLenderID',
        'guaranteedValuationServiceID',
        'heatPerSquareMetreSourceTypeCode',
        'hedonicEstimateSuspectIndicator',
        'housingStructureTypeCode',
        'lenderModelPoints',
        'lenderModelRatingTypeCode',
        'lotSizeLookupTypeCode',
        'lotSizeSquareMetreUsedCount',
        'marketAreaGeographicalTypeCode',
        'marketConditionTypeCode',
        'marketModelExceptionIndicator',
        'marketModelPoints',
        'marketModelRatingTypeCode',
        'mliPremiumDiscountAmount',
        'mliPremiumDueAmount',
        'mliPremiumPercent',
        'modelOverrideSellingPriceAmount',
        'nonRefundableAmount',
        'premiumDueOverrideReasonTypeCode',
        'premiumProvincialSalesTaxPayableAmount',
        'previousSellingPriceRejectCode',
        'priceIndexAssessmentAmount',
        'priceIndexEstimatedAmount',
        'priceIndexEstimateSourceCode',
        'priceIndexPreviousSellingPriceAmount',
        'priceIndexSellingPriceAmount',
        'propertyAgeCalculatedAmount',
        'propertyAgeOverrideIndicator',
        'propertyConstructionPeriod',
        'propertySaleAssessmentFoundIndicator',
        'propertySaleAssessmentID',
        'propertySaleAssessmentSaleFindIndicator',
        'propertyTaxUsedAmount',
        'provincialSalesTaxDiscountAmount',
        'proxySellingPriceAmount',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'riskPropertyRatingCode',
        'riskResultDecisionCode',
        'riskResultsCopiedIndicator',
        'repeatPriceIndexTypeCode',
        'supplementalCapitalRequirementIndicator',
        'taxBasedProxyValueAmount',
        'totalDebtServiceRecalculatedRatio',
        'validatedAddressResultTypeCode',
        'validatedCensusDivisionID',
        'validatedCensusSubdivisionID',
        'validatedFederalConstituencyCode',
        'validatedMetropolitanMajorAreaID',
        'validatedPropertyAddressMunicipalityName',
        'validatedPropertyAddressPostalCode',
        'validatedPropertyAddressStreetDirectionID',
        'validatedPropertyAddressStreetNumber',
        'validatedPropertyAddressStreetName',
        'validatedPropertyAddressStreetTypeID',
        'validatedPropertyAddressUnitNumber',
        'validatedProvinceID',
        'validatedStatisticsCanadaProvinceID',
        'validatedUrbanRuralCode',
        'validatedStreetNumberSuffix',
        'validatedStreetPredirectionalID',
        'validatedStreetPreTypeID',
        'validatedSubaddressTypeText',
        'weightedProxyValueAmount',
    ],
    properties: {
        transactionalRiskResultID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        cmhcAccountNumber: {
            type: 'number',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be a number with up to 12 digits',
        },
        accountStatusTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        annualHeatingCostUsedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        applicationIDTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        appraisalModelPoints: {
            type: 'number',
            maximum: 999,
            minimum: 0,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        appraisalModelRatingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        appraisalStandardAdjustmentFactor: {
            type: 'number',
            maximum: 9,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 3 digits in total and 2 digits of precision',
        },
        averagePropertyTaxAmountSourceTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        averageSellingPriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        benchmarkPropertySizeAmount: {
            type: 'number',
            maximum: 99999,
            minimum: -99999,
            errorMessage: 'should be a number with up to 5 digits in total',
        },
        benchmarkSellingPriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        calculatedPremiumDueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        canadianIncomePredictorScoreAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        cmhcFeeDiscountAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        cmhcFeesDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        cmhcOfficeID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        code1RegistrationID: {
            type: ['integer', 'null'],
            minimum: -2147483648,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        feeDueOverrideCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        femsiAmortizationPoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiBorrowerCreditInconsistencyScorePoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiBorrowerGenericCreditScorePoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiBorrowerIdentityRiskPoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiClosingPeriodLagScorePoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiCoBorrowerGenericCreditScorePoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiCoBorrowerIdentityRiskPoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiLoanToValueRatioScorePoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiOverValuedPropertyScorePoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiRestrictedAccountabilityScorePoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiScoreCardUsedTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        femsiStableBorrowerPoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        femsiTotalDebtServiceRatioScorePoints: {
            type: 'integer',
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        finalPriceEstimateAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        financialInstitutionCivicMunicipalityNameKey: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        fraudScoreUsedCount: {
            type: ['integer', 'null'],
            minimum: -32767,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        geocodingResultTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        guaranteedValuationServiceEligibleIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        guaranteedValuationServiceLenderID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        guaranteedValuationServiceID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        heatPerSquareMetreSourceTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        hedonicEstimateSuspectIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        housingStructureTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lenderModelPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        lenderModelRatingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lotSizeLookupTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lotSizeSquareMetreUsedCount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        marketAreaGeographicalTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        marketConditionTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        marketModelExceptionIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        marketModelPoints: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            errorMessage: 'should be a number with up to 3 digits in total',
        },
        marketModelRatingTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        mliPremiumDiscountAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        mliPremiumDueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        mliPremiumPercent: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            multipleOf: 0.0001,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        modelOverrideSellingPriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        nonRefundableAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        premiumDueOverrideReasonTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        premiumProvincialSalesTaxPayableAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        previousSellingPriceRejectCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        priceIndexAssessmentAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        priceIndexAssessmentDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        priceIndexEstimatedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        priceIndexEstimateDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        priceIndexEstimateSourceCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        priceIndexPreviousSellingPriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        priceIndexSellingPriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        priceIndexSellingPriceEffectiveDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        propertyAgeCalculatedAmount: {
            type: 'number',
            maximum: 99,
            minimum: -99,
            multipleOf: 0.001,
            errorMessage: 'should be a decimal with up to 5 digits in total and 3 digits of precision',
        },
        propertyAgeOverrideIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertyConstructionPeriod: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        propertySaleAssessmentFoundIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertySaleAssessmentID: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        propertySaleAssessmentSaleFindIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertyTaxUsedAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        provincialSalesTaxDiscountAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        proxySellingPriceAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        riskPropertyRatingCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        riskResultDecisionCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        riskResultsCopiedIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        repeatPriceIndexTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        supplementalCapitalRequirementIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        taxBasedProxyValueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        totalDebtServiceRecalculatedRatio: {
            type: 'number',
            maximum: 999,
            minimum: -999,
            multipleOf: 0.0001,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision',
        },
        validatedAddressResultTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedCensusDivisionID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedCensusSubdivisionID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        validatedFederalConstituencyCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        validatedMetropolitanMajorAreaID: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        validatedPropertyAddressMunicipalityName: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        validatedPropertyAddressPostalCode: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedPropertyAddressStreetDirectionID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedPropertyAddressStreetNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        validatedPropertyAddressStreetName: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters',
        },
        validatedPropertyAddressStreetTypeID: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedPropertyAddressUnitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        validatedProvinceID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedStatisticsCanadaProvinceID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedUrbanRuralCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        validatedStreetNumberSuffix: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        validatedStreetPredirectionalID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        validatedStreetPreTypeID: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        validatedSubaddressTypeText: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        weightedProxyValueAmount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        scoreCard: {
            type: 'array',
            items: transactional_risk_scorecard_schema_1.transactionalRiskScorecardSchema,
        },
    },
};
